import { html } from 'lit';
import { ago } from '../../shared/ui/format.js';
import { stateVariant, word } from '../accounts.js';
import { AccountView } from './account-view.js';

/**
 * The repositories running against this account.
 *
 * A record rather than something to maintain: a repository appears here the first time a run names it,
 * with the visibility the run was decided on. Public ones cost no seat; a repository the probe cannot
 * reach anonymously is treated as private.
 */
export class UserAccountRepositories extends AccountView
{
   static section = 'repositories';

   get body()
   {
      const rows = this.team.projects ?? [];

      return html`
         <lia-card>
            <lia-data-table
               listing-id="account-projects"
               .perPage=${10}
               no-column-manager
               .columns=${[
                  { key: 'remoteKey', label: 'Repository', sortable: true, searchable: true },
                  {
                     key: 'visibility',
                     label: 'Visibility',
                     sortable: true,
                     render: row => html`<lia-badge variant=${stateVariant(row.visibility)}>${word(row.visibility)}</lia-badge>`
                  },
                  {
                     key: 'visibilitySource',
                     label: 'Established by',
                     sortable: true,
                     render: row => sourceWord(row.visibilitySource)
                  },
                  {
                     key: 'visibilityCheckedAt',
                     label: 'Checked',
                     sortable: true,
                     render: row => (row.visibilityCheckedAt ? ago(row.visibilityCheckedAt) : 'Never')
                  }
               ]}
               .rows=${rows}
               .rowKey=${row => row.id}
               empty-title="Nothing has run yet"
               empty-message="A repository appears here the first time a run names it."
            ></lia-data-table>
         </lia-card>`;
   }
}

function sourceWord(source)
{
   switch (source)
   {
   case 'probe':
      return 'Checked';
   case 'manual':
      return 'Set by hand';
   case 'assumed':
      return 'Assumed private';
   default:
      return word(source);
   }
}

customElements.define('user-account-repositories', UserAccountRepositories);
